<template>
    <!-- 【美田企微】新春营销激励-激励在线 -->
    <div class="ranking" v-if="role">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <img class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/bannerManager22.png`" alt="banner" v-if="currentJobTab === '3' && currentGroupMillionTab === '权益金达标激励'">
            <img class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/${getTheme('bannerImg')}.png`" alt="banner" v-else>
            <div class="reward-box">
                <div v-if="currentJobTab === '2'" class="reward-img">
                    <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/awardsKh.png" alt="left image">
                </div>
                <div v-else-if="currentJobTab === '3' && currentGroupMillionTab === '权益金达标激励'" class="reward-img">
                    <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/awardsZr1.png" alt="left image">
                </div>
                <div v-else class="reward" :class="[`baseHeight${currentJobTab}`]" :style="{ backgroundImage: `url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/${getTheme('rewardImg')}.png)` }">
                    <div class="reward-data left">
                        <div class="text">{{ getThemeBonus('rewardText1') }}</div>
                        <div class="text" v-html="getThemeBonus('rewardText2')"></div>
                    </div>
                    <div class="reward-data" v-show="currentJobTab === '1'">
                        <img :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/${getGroupBonus('rewardText2_1')}.png`" alt="banner" />
                    </div>
                    <div class="reward-data" v-show="currentJobTab !== '1' && currentJobTab !== '3'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/cash.png" alt="left image">
                    </div>
                    <div class="reward-data right" v-show="currentJobTab === '3'">
                        <img :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-12-25/${getGroupBonus('rewardText2_3')}.png`" alt="banner" />
                    </div>
                </div>
                <img v-if="!myInfo" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status1.png">
                <template v-else>
                    <img v-if="!isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status2.png">
                    <img v-if="!isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status33.png">
                    <img v-if="isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status4.png">
                    <img v-if="isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status5.png">
                </template>
                <!-- 区域经理和主任展示 -->
                <!-- <div v-if="dataInfo?.timePer">标准激励进度：<span class="red">{{ dataInfo.timePer }}%</span></div> -->
                <template v-if="myInfo">
                    <p class="reachBz" v-if="!(currentJobTab === '3' && currentGroupMillionTab === '权益金达标激励')">标准激励进度：<span :class="[myInfo.motivateProgress < 100 ? 'red' : 'blue']">{{ myInfo.motivateProgress }}%</span></p>
                    <p class="reach" v-if="currentJobTab === '1' || (currentJobTab === '3' && currentGroupMillionTab === '收入达标激励')">{{ getTheme('achieve') }}{{ isReach ? '已达成' : '未达成' }}</p>
                    <div class="compare compare-center" v-if="currentJobTab === '2'">
                        <div class="compare-data">
                            <p>我的</p>
                            <p>本宫+归壤+生美抗衰联合卡销售额(达成率)</p>
                            <p class="blue">{{ myInfo.openOrderAmt }}
                                <span>W</span>
                                <span class="red fs-32">({{ myInfo.daChengRatio }}%)</span>
                            </p>
                        </div>
                    </div>
                    <div class="compare compare-center" style="margin-top: 0;" v-else-if="currentJobTab === '3' && currentGroupMillionTab === '权益金达标激励'">
                        <div class="compare-data">
                            <div v-if="myInfo.isAward2602">{{ myInfo.isAward2602 }}</div>
                            <div v-if="myInfo.timePer2" style="margin-top: 20px;">标准激励进度：<span class="red">{{ myInfo.timePer2 }}%</span></div>
                            <p>我的门店 当前权益金</p>
                            <!-- <p>当前权益金</p> -->
                            <p class="blue fs-46 red">
                                {{ myInfo.openOrderAmt }}W
                            </p>
                            <p class="blue dcl">
                                <span class="red">达成率：{{ myInfo.daChengRatio }}% 同比：{{ myInfo.sameRatio }}%</span>
                            </p>
                        </div>
                    </div>
                    <div class="compare" v-else>
                        <div class="compare-data">
                            <p>{{ getTheme('leftText1') }}</p>
                            <p>{{ getTheme('leftText2') }}</p>
                            <p class="red" v-if="currentJobTab === '3'">
                                {{ myInfo.daChengRatio }}<span>%</span>
                            </p>
                            <p class="blue" v-if="currentJobTab === '1'">{{ myInfo.openOrderAmt }}
                                <span>W</span>
                            </p>
                        </div>
                        <img v-if="currentJobTab !== '2'" class="less" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/${compare()}.png`">
                        <div class="compare-data">
                            <p v-if="currentJobTab !== '2'">{{ getTheme('rightText1') }}</p>
                            <p>{{ getTheme('rightText2') }}</p>
                            <p class="red" v-if="currentJobTab === '3'">
                                {{ twentyOpenOrderAmt }}<span>%</span>
                            </p>
                            <p class="red" v-if="currentJobTab === '1'">{{ twentyOpenOrderAmt }}
                                <span v-if="currentJobTab === '1'">W</span>
                                <span v-else>%</span>
                            </p>
                        </div>
                    </div>

                </template>
                <p class="update-time">{{ getTheme('updateTime') }} {{ today }}</p>
            </div>

            <div class="bg-color" :style="{ backgroundColor: getTheme('bgColor') }"></div>

            <div class="ranking-box">
                <div class="ranking-box-hd">
                    <div :class="{ on: isStore === 0 }" @click="onTabChange(0)">全部</div>
                    <div :class="{ on: isStore === 1 }" @click="onTabChange(1)">本店</div>
                </div>

                <div class="tabs-box">
                    <div class="job-tabs">
                        <div class="job-tab-item" :class="{ on: currentJobTab === it.dictValue }" v-for="it in jobTabs" :key="it.dictValue" @click="onJobTab(it.dictValue)">
                            {{ it.dictLabel }}
                        </div>
                    </div>
                    <div class="group-tabs" v-if="currentJobTab === '3'">
                        <div class="group-tab-item" :style="{ backgroundColor: currentGroupMillionTab === it ? getTheme('btnBgColor') : '#E6E6E6' }" :class="{ on: currentGroupMillionTab === it }" v-for="it in groupMillionTabs" :key="it" @click="onGroupMillionTab(it)">
                            {{ it }}
                        </div>
                    </div>
                    <div class="group-tabs" v-if="(currentGroupMillionTab === '收入达标激励' && currentJobTab === '3') || currentJobTab === '1'">
                        <div class="group-tab-item" :style="{ backgroundColor: currentGroupTab === it ? getTheme('btnBgColor') : '#E6E6E6' }" :class="{ on: currentGroupTab === it }" v-for="it in groupTabs" :key="it" @click="onGroupTab(it)">
                            {{ it }}
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="table-container">
                        <FixedColumnTable :columns="jobTabs[Number(currentJobTab) - 1].columns" :data="list" :myInfo="myInfo" :myFlag="myFlag" :currentJobTab="currentJobTab" :currentGroupMillionTab="currentGroupMillionTab" :currentGroupTab="currentGroupTab" />
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import FixedColumnTable from './FixedColumnTable.vue';
    import { uniqueId, debounce } from 'lodash';
    import { getCookie } from '@/utils';
    import { Toast } from 'vant'
    export default {
        name: 'RankingList',
        components: {
            FixedColumnTable
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                myFlag: true,
                jobTabs: [], // 职位分类标签列表
                currentJobTab: '1', // ['美疗师', '客户经理', '主任']
                groupTabs: [], // 分组标签列表
                groupMillionTabs: ['收入达标激励', '权益金达标激励'], // 分组标签列表
                currentGroupTab: '第1组', // 当前选中的分组
                currentGroupMillionTab: '收入达标激励', // 当前选中的分组
                loading: false, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                today: new Date().getMonth() + 1 + '月' + new Date().getDate() + '日', // 当前日期，格式为"月日"
                hour: new Date().getHours(), // 当前小时数
                error: false, // 是否发生错误
                myInfo: {}, // 当前用户的数据
                isAward: false, // 是否获奖
                isReach: false, // 是否达到目标
                isMillion: '0', // 是否是百万大咖
                dataInfo: {},
                isEnd: new Date().getTime() > new Date('2026-02-28 23:59:59').getTime(), // 活动是否已结束
                twentyOpenOrderAmt: 0, // 对比数据，用于与当前用户数据进行对比
                myData: 0,// 当前用户的数据，用于展示用户自身排名信息
                postId: '', // 员工id
                monthValue: '1', // 月份值，只有主任有1月是1,2月是2
                // 员工id列表, 分别对应['美疗师', '技术监理', '客户经理', '主任', '区经']
                //postIdList: [['7'], ['4'], ['2', '42'], ['1'], ['11', '1472787652026765457', '1472787652026765732']],
                postIdList: [['7'], ['2', '4', '42'], ['1'], ['11', '1472787652026765457', '1472787652026765732']],
                role: '', // 当前用户的角色
            }
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.postIdList.forEach((it, i) => {
                if (it.includes(this.postId)) {
                    this.role = i + 1 + ''
                }
            })
            this.role = this.role === '4' ? '3' : this.role
            // if (!this.role) {
            //     this.$dialog.alert({
            //         title: '提示',
            //         message: '当前用户暂无权限, 请返回',
            //     }).then(() => {
            //         this.$router.back()
            //     });
            //     return
            // }

            this.currentJobTab = this.role
            this.getjobTabs()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function (reset) {
                if (this.finished) return
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                try {
                    const params = {
                        groupNo: this.currentJobTab !== '2' ? this.currentGroupTab : '',
                        limit: 10,
                        searchType: this.isStore,
                        type: this.currentJobTab,
                        monthValue: this.currentJobTab === '3' ? this.monthValue : '',
                        page: this.page
                    }
                    const { msg, data } = await request({
                        url: '/sm/new-year/ranking/getRankingInfoPage',
                        method: 'get',
                        params
                    })
                    Toast.clear();
                    if (msg !== 'success') {
                        throw new Error(msg)
                    }
                    this.dataInfo = data || {}
                    const list = data && data.rankingList || []
                    this.myInfo = data && data.empRankingInfo
                    // list = list.map(it => {
                    //     it.uniqueId = uniqueId()
                    //     return it
                    // })
                    // this.list直接赋值, 不置空, 防止页面高度丢失导致闪屏
                    if (this.page === 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.isAward = data.isReward * 1
                    this.isReach = data.isReach * 1
                    this.twentyOpenOrderAmt = data.twentyOpenOrderAmt
                    this.myData = data.myData

                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.list = []
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 获取职位分类标签
            getjobTabs() {
                let data = [
                    {
                        dictLabel: '美疗师',
                        dictValue: '1',
                        columns: [{
                            title: '排名',
                            key: 'rankNum',
                            width: '40px'
                        },
                        {
                            title: '美疗师',
                            key: 'empName',
                            width: '140px'
                        },
                        {
                            title: '开单额',
                            key: 'openOrderAmt',
                            width: '100px'
                        },
                        {
                            title: '预计获得奖金',
                            key: 'awardAmt',
                            width: '130px'
                        }]
                    },
                    {
                        dictLabel: '客户经理',
                        dictValue: '2',
                        columns: [{
                            title: '排名',
                            key: 'rankNum',
                            width: '40px'
                        },
                        {
                            title: '客户经理',
                            key: 'empName',
                            width: '140px'
                        },
                        {
                            title: '关键项目销售额',
                            key: 'openOrderAmt',
                            width: '100px'
                        },
                        {
                            title: '达成率',
                            key: 'daChengRatio',
                            width: '100px'
                        },
                        {
                            title: '预计获得奖金',
                            key: 'awardAmt',
                            width: '130px'
                        }]
                    },
                    {
                        dictLabel: '主任',
                        dictValue: '3',
                        columns: [{
                            title: '排名',
                            key: 'rankNum',
                            width: '40px'
                        },
                        {
                            title: '主任',
                            key: 'empName',
                            width: '140px'
                        },
                        {
                            title: '收入',
                            key: 'openOrderAmt',
                            width: '100px'
                        },
                        {
                            title: '达成率',
                            key: 'daChengRatio',
                            width: '100px'
                        },
                        {
                            title: '预计获得奖金',
                            key: 'awardAmt',
                            width: '130px'
                        }]
                    },
                ]
                this.jobTabs = data.filter((it, i) => {
                    if (this.role === '1') {
                        return i < 1
                    }
                    if (this.role === '2') {
                        return i < 2
                    }
                    if (this.role === '3') {
                        return true
                    }
                })
                const d = new Date();
                d.setDate(d.getDate() - 1);
                this.today = (d.getMonth() + 1) + '月' + d.getDate() + '日'
                if (this.currentJobTab === '2') {
                    this.today = new Date().getMonth() + 1 + '月' + new Date().getDate() + '日'
                    this.isEnd = new Date().getTime() > new Date('2026-03-05 23:59:59').getTime()
                } else if (this.currentJobTab === '3') {
                    this.today = new Date().getMonth() + 1 + '月' + new Date().getDate() + '日'
                    this.isEnd = new Date().getTime() > new Date('2026-01-31 23:59:59').getTime()
                }
                this.getGroupTab()
            },
            // 获取分组标签
            async getGroupTab() {
                const { data } = await request({
                    url: '/sm/new-year/ranking/getGroupNoTab',
                    method: 'get',
                    params: { type: this.currentJobTab, monthValue: this.currentJobTab === '3' ? this.monthValue : '', }
                })
                this.groupTabs = data && data.groupNoList && data.groupNoList.length > 0 ? data.groupNoList : []
                this.currentGroupTab = data && data.groupNo ? data.groupNo : data && data.groupNoList[0] // 默认选中
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                if (this.currentJobTab === value) return
                // if (value === '5' && this.isStore === 1) {
                //     this.$toast('区经无法选择本店!')
                //     return
                // }
                this.currentGroupMillionTab = '收入达标激励'
                this.monthValue = '1'
                this.currentJobTab = value;
                this.page = 1
                this.finished = false
                this.error = false;
                // this.isStore = 0
                const d = new Date();
                d.setDate(d.getDate() - 1);
                this.today = (d.getMonth() + 1) + '月' + d.getDate() + '日'
                this.isEnd = new Date().getTime() > new Date('2026-02-28 23:59:59').getTime()
                if (value === '2') {
                    this.today = new Date().getMonth() + 1 + '月' + new Date().getDate() + '日'
                    this.isEnd = new Date().getTime() > new Date('2026-03-05 23:59:59').getTime()
                } else if (value === '3') {
                    this.today = new Date().getMonth() + 1 + '月' + new Date().getDate() + '日'
                    this.isEnd = new Date().getTime() > new Date('2026-01-31 23:59:59').getTime()
                    this.jobTabs[2].columns = [{
                        title: '排名',
                        key: 'rankNum',
                        width: '40px'
                    },
                    {
                        title: '主任',
                        key: 'empName',
                        width: '140px'
                    },
                    {
                        title: '收入',
                        key: 'openOrderAmt',
                        width: '100px'
                    },
                    {
                        title: '达成率',
                        key: 'daChengRatio',
                        width: '100px'
                    },
                    {
                        title: '预计获得奖金',
                        key: 'awardAmt',
                        width: '130px'
                    }]
                }

                this.getGroupTab()
            },

            // 切换主任1,2月
            onGroupMillionTab(value) {
                if (this.currentGroupMillionTab === value) return
                this.currentGroupMillionTab = value;
                this.monthValue = value === '收入达标激励' ? '1' : value === '权益金达标激励' ? '2' : ''
                this.finished = false
                this.error = false;
                this.page = 1
                if (value === '收入达标激励') {
                    this.isEnd = new Date().getTime() > new Date('2026-01-31 23:59:59').getTime()
                    this.getGroupTab()
                    this.jobTabs[2].columns = [{
                        title: '排名',
                        key: 'rankNum',
                        width: '40px'
                    },
                    {
                        title: '主任',
                        key: 'empName',
                        width: '140px'
                    },
                    {
                        title: '收入',
                        key: 'openOrderAmt',
                        width: '100px'
                    },
                    {
                        title: '达成率',
                        key: 'daChengRatio',
                        width: '100px'
                    },
                    {
                        title: '预计获得奖金',
                        key: 'awardAmt',
                        width: '130px'
                    }]
                } else {
                    this.isEnd = new Date().getTime() > new Date('2026-02-14 23:59:59').getTime()
                    this.currentGroupTab = ''
                    this.getDataList()
                    this.jobTabs[2].columns = [{
                        title: '排名',
                        key: 'rankNum',
                        width: '40px'
                    },
                    {
                        title: '主任',
                        key: 'empName',
                        width: '140px'
                    },
                    {
                        title: '权益金',
                        key: 'openOrderAmt',
                        width: '100px'
                    },
                    {
                        title: '达成率',
                        key: 'daChengRatio',
                        width: '100px'
                    },
                    {
                        title: '同比',
                        key: 'sameRatio',
                        width: '100px'
                    },
                    {
                        title: '预计获得奖金',
                        key: 'awardAmt',
                        width: '130px'
                    }]
                }
            },
            // 切换分组标签
            onGroupTab(value) {
                if (this.currentGroupTab === value) return
                this.currentGroupTab = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()

            },
            // 切换全部/本店标签
            onTabChange(value) {
                if (this.isStore === value) return
                // if (this.currentJobTab === '5') {
                //     this.$toast('区经无法选择本店!')
                //     return
                // }
                if (this.currentJobTab === '3') {

                }
                this.isStore = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()
            },
            compare() {
                if (this.currentJobTab === '1') {
                    return Number(this.myInfo.openOrderAmt) > Number(this.twentyOpenOrderAmt) ? 'more' : this.myInfo.openOrderAmt === this.twentyOpenOrderAmt ? 'equal' : 'less'
                } else {
                    return Number(this.myInfo.daChengRatio) > Number(this.twentyOpenOrderAmt) ? 'more' : this.myInfo.daChengRatio === this.twentyOpenOrderAmt ? 'equal' : 'less'
                }

            },
            // 获取主题色和图片和文字
            getTheme(type) {
                if (this.jobTabs.length === 0) return
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    bgColor: ['#AB080B', '#AB080B', '#90002C', '#BB1E21', '#BB1E21'],
                    btnBgColor: ['#AB080B', '#AB080B', '#AB080B', '#844FC7', '#844FC7'],
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#FBE2BE', '#FFE7E7', '#FFE7E7'],
                    bannerImg: ['bannerBeauty', 'bannerSkill', 'bannerManager11', 'bannerDirector', 'bannerArea'],
                    rewardImg: ['bg11', 'bg11', 'bg11', 'bg45', 'bg45'],
                    ruleImg: ['rule1', 'rule1', 'rule2', 'rule3', 'rule3'],
                    leftText1: ['我的', '我的门店', '我的门店', '我的门店', '我的区域'],
                    leftText2: ['自营护理开单额', '当前非0护理客流达成率', '当前收入达成率', '当前权益金', '当前权益金'],
                    rightText1: ['第20名美疗师', '第10名门店', '前20%门店', '我的门店', '我的区域'],
                    rightText2: ['自营护理开单额', '当前非0护理客流达成率', '当前最低收入达成率', '当前营业收入', '当前营业收入'],
                    updateTime: ['数据更新时间', '数据更新时间', '数据更新时间', '权益金、营业收入数据更新时间', '权益金、营业收入数据更新时间'],
                    title1: ['美疗师', '门店', '客户经理', '主任', '区经'],
                    title2: ['开单额', '客流', '产品销售额 ', '权益金', '权益金'],
                    title3: ['预计瓜分奖金', '预计获得奖金', '预计获得奖金', '预计瓜分奖金', '预计瓜分奖金'],
                    achieve: ['2026年1+2月门店非0护理开单客流、营业收入当前进度', '2025年11+12月门店非0护理客流、营业收入', '2026年1+2月门店权益金、营业收入当前进度', '2025年11+12月门店权益金、营业收入当前进度', '2025年11+12月区域权益金、营业收入当前进度'],
                    list: ['mlsSalekpiList', 'jsjlSalekpiList', 'empSalekpiList', 'dirctSalekpiList', 'managerSalekpiList'],
                    info: ['mlsSalekpi', 'jsjlSalekpi', 'empSalekpi', 'dirctSalekpi', 'managerSalekpi']

                }
                return theme[type][index];
            },
            // 将二次套娃的单独拿出来, 减少代码触发判断的次数
            getThemeBonus(type) {
                if (this.groupTabs.length === 0 || this.jobTabs.length === 0) return 0
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    rewardText1: [`组内前${this.getGroupBonus('rewardText1_1')}名`, ``, '组内收入达成率排名前20%门店', ''],
                    rewardText2: [`获得<span class="red bold font30">${this.getGroupBonus('rewardText2_1')}元</span>奖金`, '', `获得<span class="red">${this.getGroupBonus('rewardText2_3')}元</span>现金`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_4')}元</span>奖金池`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_5')}元</span>奖金池`],
                }
                return theme[type][index];
            },
            // 根据分组展示不同的数据
            getGroupBonus(type) {
                const index = this.groupTabs.findIndex(it => it === this.currentGroupTab)
                const theme = {
                    rewardText2_1: ['300', '200', '200', '200', '100'],
                    rewardText1_1: [20, 30, 30, 30, 30],
                    rewardText2_3: ['1000', '800', '500', '300'],
                    top16_30: [800, 600, 400, 200],
                    rewardText2_4: [12000, 25000, 20000, 15000],
                    rewardText2_5: [20000, 15000, 10000],
                }
                return theme[type][index]
            },
            toRule() {
                this.$router.push({ path: '/Rule' })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;

        .bold {
            font-weight: bolder;
        }

    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
    }

    .reward-box {
        position: relative;
        width: 100%;
        // height: 860px;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            margin-bottom: 30px;
        }

        .reach {
            font-size: 28px;
        }

        .reachBz {
            margin: 0;
        }

        .baseHeight1 {
            height: 349px;
        }

        .baseHeight2 {
            height: 349px;
        }

        .baseHeight3 {
            height: 349px;

            .left {
                flex: none;
                width: 70%;
            }

            .right {
                flex: none;
                width: 30%;
            }
        }

        .baseHeight4,
        .baseHeight5 {
            height: 348px;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 350px;
        padding-bottom: 30px;
        padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/bg.png');
        background-size: 100% 100%;

        &.left {
            padding-right: 30px;
            padding-left: 20px;

            .reward-data:nth-of-type(1) {
                flex: 1.7;
            }
        }

        .reward-data {
            flex: 1;
            text-align: center;

            >img {
                height: 150px;
            }
        }
    }

    .reward-img {
        display: flex;
        width: 100%;
        margin-bottom: 30px;

        img {
            width: 100%;
        }
    }



    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 90%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
                margin-top: 3px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }

            .fs-46 {
                font-size: 46px;
            }

            .dcl {
                margin-top: 0;

                span {
                    font-size: 36px;
                }
            }
        }
    }

    .compare-center {
        justify-content: center;
    }

    .update-time {
        font-size: 24px;
        color: #999999;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;

        >div {
            width: 50%;
            line-height: 100px;
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            background-color: #F5F5F5;

            &.on {
                color: #333333;
                background-color: #ffffff;
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        display: flex;
        align-items: center;
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        padding: 30px 0;
        margin-right: 50px;
        font-weight: 500;
        position: relative;

        &.on {

            color: #333333;
            font-weight: bold;

            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: 20px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        overflow-x: scroll;
        white-space: nowrap;
    }

    .group-tab-item {
        height: 40px;
        padding: 0 30px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            background-color: #AB080B;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 100px;
        text-align: center;
    }

    .ranking-orderT {
        width: 140px;
    }

    .ranking-bonus {
        width: 130px;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
        }

        .bold {
            font-weight: bold !important;
        }

        .font30 {
            font-size: 30px;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
